// StepsContainer.tsx
import { Button } from '#GameFrontend/components/ui/button';
import { ScrollArea } from '#GameFrontend/components/ui/scroll-area';
import { t } from 'i18next';
import React from 'react';
import { Check } from 'react-feather';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface StepsContainerProps {
	currentStep: number;
	stepHandler: (step: number) => void;
}

const StepsContainer: React.FC<StepsContainerProps> = ({ currentStep, stepHandler }) => {
	const navigate = useNavigate();
	const handleBack = () => {
		if (currentStep === 1) {
			navigate('/');
		}
		stepHandler(currentStep - 1);
	};

	return (
		<div className="flex flex-col flex-grow">
			{/* Mobile Steps */}
			<div className="lg:hidden">
				<div className="relative flex justify-between items-start">
					<div
						className={`absolute left-[15%] right-[${currentStep === 2 ? '50%' : '15%'}] h-[5px] bg-[#fb923c] font-bold ${currentStep === 1 ? 'hidden' : ''}`}
						style={{ top: '23%' }}
					></div>
					<div
						className="absolute left-[15%] right-[15%] h-[5px] bg-[#fb923c] font-bold opacity-35"
						style={{ top: '23%' }}
					></div>
					{[1, 2, 3].map((step) => (
						<div key={step} className="relative flex-1 flex flex-col items-center text-center">
							<div
								className={`z-10 flex items-center justify-center w-8 h-8 rounded-full text-white text-sm mb-2 
              ${step <= currentStep ? 'bg-[#fb923c]' : 'bg-[#b26b48] text-opacity-55'}
              ${step === currentStep ? 'border-white border-2' : ''}
              `}
							>
								{step < currentStep ? <Check className="w-4 h-4 text-white" /> : step}
							</div>
							<span className={`text-xs text-white ${currentStep !== step ? 'text-opacity-55' : ''}`}>
								{step === 1
									? t('register.steps.breed')
									: step === 2
										? t('register.steps.customize')
										: t('register.steps.info')}
							</span>
						</div>
					))}
				</div>
			</div>

			{/* Desktop Steps */}
			<div className="hidden lg:flex flex-grow py-6 xl:p-6 flex-col text-white">
				<div className="flex flex-col justify-between h-full">
					<div className="flex flex-grow flex-col">
						{[1, 2, 3].map((step) => (
							<div
								key={step}
								className={`flex flex-grow ${currentStep === step ? 'flex-grow-[3]' : ''} flex-col`}
							>
								<div className="flex flex-grow items-center space-x-4 mb-6">
									<div
										className={`flex items-center justify-center ${currentStep === step ? 'w-10 h-10' : 'w-8 h-8'}  rounded-full font-bold flex-shrink-0 
                  ${step <= currentStep ? 'bg-[#fb923c] ' : 'bg-[#c2410c] bg-opacity-75'} 
                  ${step === currentStep ? 'border-white border-2' : ''}
                  `}
									>
										{step < currentStep ? <Check className="w-4 h-4 text-white" /> : step}
									</div>
									<span
										className={`xl:text-xl lg:text-lg ${currentStep === step ? 'drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]' : 'text-white'}`}
									>
										{step === 1
											? t('register.steps.breed')
											: step === 2
												? t('register.steps.customize')
												: t('register.steps.info')}
									</span>
								</div>
								{currentStep === step && (
									<div className="flex flex-grow">
										<ScrollArea className="flex rounded-md p-4 bg-amber-100 bg-opacity-25 shadow-md xl:mr-16 max-h-64 xl:max-h-full">
											{currentStep === 1 && (
												<>
													<h3 className="font-lobster text-3xl mb-4 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">
														{t('register.steps.title')}
													</h3>
													<Trans
														i18nKey="register.breed.text"
														components={{
															br: <br />,
														}}
													/>
												</>
											)}
											{currentStep === 2 && (
												<>
													<h3 className="font-lobster text-3xl mb-4 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">
														{t('register.steps.title')}
													</h3>
													<Trans
														i18nKey="register.customize.text"
														components={{
															br: <br />,
														}}
													/>
												</>
											)}
											{currentStep === 3 && (
												<>
													<h3 className="font-lobster text-3xl mb-4 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">
														{t('register.steps.title')}
													</h3>
													<Trans
														i18nKey="register.info.text"
														components={{
															br: <br />,
														}}
													/>
												</>
											)}
										</ScrollArea>
									</div>
								)}
							</div>
						))}
					</div>
					<div className="flex justify-between mt-8">
						{currentStep !== 4 && (
							<Button
								variant="ghost"
								className="text-white hover:text-[#fb923c] hover:bg-white bg-[#fb923c]"
								onClick={handleBack}
							>
								{'< ' + t('back.button')}
							</Button>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default StepsContainer;
